import React from 'react';

// Shown on the inventory dashboards when the server answered from the mirror
// because NetSuite was unavailable. Without it the numbers look live: the
// figures are frozen at the lockout cutoff (plus whatever moved natively since),
// and on stock-by-location the per-location split cannot be answered at all.
function MirrorNotice({ data }) {
  if (!data || (data.source !== 'mirror' && !data.lockout)) return null;
  const cutoff = data.mirror_cutoff || data.as_of;
  return (
    <div className="mirror-notice">
      <span className="mirror-notice-badge">NetSuite unavailable</span>
      <span className="mirror-notice-text">
        {data.note || 'Served from the mirror.'}
        {cutoff ? ` As of ${new Date(cutoff).toLocaleString()}.` : ''}
      </span>
    </div>
  );
}

export default MirrorNotice;
